// unlockPrivateStream.js
'use strict';
import openRecommendDiamondPackSelector from '../action/openRecommendDiamondPackSelector.js';
import setPrivateStreamAutoPayment from '../action/setPrivateStreamAutoPayment.js';
import setShouldSubmitStreamPaymentOnSdPreset from '../action/setShouldSubmitStreamPaymentOnSdPreset.js';
import setIsPrivateStreamUnlocked from '../action/setIsPrivateStreamUnlocked.js';

import getLiveStreamData from '../selector/getLiveStreamData.js';

/**
 * Unlock private stream
 * @kind action
 * @param {string} {streamId} - stream id.
 * @return {Promise} Action promise.
 */
const unlockPrivateStream =
  ({ streamId }) =>
  async (dispatch, getState) => {
    if (!streamId) return dispatch({ type: '' });

    const productId = getLiveStreamData(
      getState(),
      [streamId, 'shop'],
      'productId'
    );
    if (productId) {
      return openRecommendDiamondPackSelector({
        productIds: [productId],
        via: 'unlock-livestream',
        recommendProductId: productId,
      });
    }

    const sessionId = getLiveStreamData(getState(), [streamId], 'sessionId');

    dispatch(setPrivateStreamAutoPayment({ streamId, isEnabled: true }));
    dispatch(
      setShouldSubmitStreamPaymentOnSdPreset({
        streamId,
        sessionId,
        shouldSubmitStreamPaymentOnSdPreset: true,
      })
    );
    dispatch(
      setIsPrivateStreamUnlocked({
        streamId,
        isPrivateStreamUnlocked: true,
      })
    );
  };

export default unlockPrivateStream;
